import { JourneyLayout } from "@/components/journey/JourneyLayout";
import { VerseDisplay } from "@/components/journey/VerseDisplay";
import { gratitudeVerses } from "@/data/verses";

export default function JourneyGratitude() {
  return (
    <JourneyLayout title="Gratitude">
      <VerseDisplay verses={gratitudeVerses} />
    </JourneyLayout>
  );
}